// source: cost_analysis.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.CostDataSource', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.displayName = 'proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.displayName = 'proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.displayName = 'proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.displayName = 'proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
totalTokens: jspb.Message.getFieldWithDefault(msg, 1, 0),
tokenBreakdown: (f = msg.getTokenBreakdown()) && proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.toObject(includeInstance, f),
estimatedTotalCostUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
model: jspb.Message.getFieldWithDefault(msg, 4, ""),
pricingDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
depthCountsMap: (f = msg.getDepthCountsMap()) ? f.toObject(includeInstance, undefined) : [],
processingMetadata: (f = msg.getProcessingMetadata()) && proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.toObject(includeInstance, f),
contextWindowSize: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata;
  return proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalTokens(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.deserializeBinaryFromReader);
      msg.setTokenBreakdown(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEstimatedTotalCostUsd(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPricingDate(value);
      break;
    case 6:
      var value = msg.getDepthCountsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readInt32, null, 0, 0);
         });
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.deserializeBinaryFromReader);
      msg.setProcessingMetadata(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContextWindowSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalTokens();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTokenBreakdown();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getEstimatedTotalCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPricingDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDepthCountsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeInt32);
  }
  f = message.getProcessingMetadata();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.serializeBinaryToWriter
    );
  }
  f = message.getContextWindowSize();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int32 total_tokens = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getTotalTokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setTotalTokens = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TokenBreakdown token_breakdown = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getTokenBreakdown = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setTokenBreakdown = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.clearTokenBreakdown = function() {
  return this.setTokenBreakdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.hasTokenBreakdown = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double estimated_total_cost_usd = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getEstimatedTotalCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setEstimatedTotalCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string pricing_date = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getPricingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setPricingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<int32, int32> depth_counts = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getDepthCountsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.clearDepthCountsMap = function() {
  this.getDepthCountsMap().clear();
  return this;
};


/**
 * optional ProcessingMetadata processing_metadata = 7;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getProcessingMetadata = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata, 7));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setProcessingMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.clearProcessingMetadata = function() {
  return this.setProcessingMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.hasProcessingMetadata = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 context_window_size = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.getContextWindowSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.prototype.setContextWindowSize = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.toObject = function(includeInstance, msg) {
  var f, obj = {
nonCachedInput: (f = msg.getNonCachedInput()) && proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject(includeInstance, f),
cachedContent: (f = msg.getCachedContent()) && proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject(includeInstance, f),
output: (f = msg.getOutput()) && proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject(includeInstance, f),
thinking: (f = msg.getThinking()) && proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject(includeInstance, f),
toolUse: (f = msg.getToolUse()) && proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown;
  return proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader);
      msg.setNonCachedInput(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader);
      msg.setCachedContent(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader);
      msg.setOutput(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader);
      msg.setThinking(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader);
      msg.setToolUse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonCachedInput();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter
    );
  }
  f = message.getCachedContent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter
    );
  }
  f = message.getOutput();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter
    );
  }
  f = message.getThinking();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter
    );
  }
  f = message.getToolUse();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional TokenTypeMetadata non_cached_input = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.getNonCachedInput = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.setNonCachedInput = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.clearNonCachedInput = function() {
  return this.setNonCachedInput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.hasNonCachedInput = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TokenTypeMetadata cached_content = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.getCachedContent = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.setCachedContent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.clearCachedContent = function() {
  return this.setCachedContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.hasCachedContent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TokenTypeMetadata output = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.getOutput = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.setOutput = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.clearOutput = function() {
  return this.setOutput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.hasOutput = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TokenTypeMetadata thinking = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.getThinking = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.setThinking = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.clearThinking = function() {
  return this.setThinking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.hasThinking = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TokenTypeMetadata tool_use = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.getToolUse = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.setToolUse = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.clearToolUse = function() {
  return this.setToolUse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenBreakdown.prototype.hasToolUse = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
tokenCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
costUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
ratePerMillion: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
discountPercent: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata;
  return proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTokenCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCostUsd(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRatePerMillion(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscountPercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokenCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRatePerMillion();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 token_count = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.getTokenCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.setTokenCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double cost_usd = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.getCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.setCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double rate_per_million = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.getRatePerMillion = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.setRatePerMillion = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 discount_percent = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.getDiscountPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.setDiscountPercent = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.clearDiscountPercent = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.TokenTypeMetadata.prototype.hasDiscountPercent = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
durationMs: jspb.Message.getFieldWithDefault(msg, 1, 0),
itemsAnalyzed: jspb.Message.getFieldWithDefault(msg, 2, 0),
processingRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
cachingEfficiencyPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
batchInfo: (f = msg.getBatchInfo()) && proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata;
  return proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDurationMs(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemsAnalyzed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProcessingRate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCachingEfficiencyPercent(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.deserializeBinaryFromReader);
      msg.setBatchInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDurationMs();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getItemsAnalyzed();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getProcessingRate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getCachingEfficiencyPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getBatchInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 duration_ms = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.getDurationMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.setDurationMs = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 items_analyzed = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.getItemsAnalyzed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.setItemsAnalyzed = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double processing_rate = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.getProcessingRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.setProcessingRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double caching_efficiency_percent = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.getCachingEfficiencyPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.setCachingEfficiencyPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional BatchProcessingInfo batch_info = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.getBatchInfo = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} returns this
*/
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.setBatchInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.clearBatchInfo = function() {
  return this.setBatchInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.ProcessingMetadata.prototype.hasBatchInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
totalBatches: jspb.Message.getFieldWithDefault(msg, 1, 0),
batchSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
parallelProcessing: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
avgBatchDurationMs: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo;
  return proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalBatches(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatchSize(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setParallelProcessing(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgBatchDurationMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalBatches();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBatchSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getParallelProcessing();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAvgBatchDurationMs();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional int32 total_batches = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.getTotalBatches = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.setTotalBatches = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 batch_size = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.getBatchSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.setBatchSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool parallel_processing = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.getParallelProcessing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.setParallelProcessing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double avg_batch_duration_ms = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.getAvgBatchDurationMs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.BatchProcessingInfo.prototype.setAvgBatchDurationMs = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.toObject = function(includeInstance, msg) {
  var f, obj = {
modelCostsMap: (f = msg.getModelCostsMap()) ? f.toObject(includeInstance, proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.toObject) : [],
totalCostUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
totalTokens: jspb.Message.getFieldWithDefault(msg, 3, 0),
primaryModel: jspb.Message.getFieldWithDefault(msg, 4, ""),
totalDurationMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalItemsAnalyzed: jspb.Message.getFieldWithDefault(msg, 6, 0),
pricingDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
combinedDepthCountsMap: (f = msg.getCombinedDepthCountsMap()) ? f.toObject(includeInstance, undefined) : [],
costDataSource: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis;
  return proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getModelCostsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.deserializeBinaryFromReader, "", new proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata());
         });
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalCostUsd(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalTokens(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalDurationMs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItemsAnalyzed(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPricingDate(value);
      break;
    case 8:
      var value = msg.getCombinedDepthCountsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readInt32, null, 0, 0);
         });
      break;
    case 9:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.cost.CostDataSource} */ (reader.readEnum());
      msg.setCostDataSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelCostsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata.serializeBinaryToWriter);
  }
  f = message.getTotalCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTotalTokens();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrimaryModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTotalDurationMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getTotalItemsAnalyzed();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPricingDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCombinedDepthCountsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeInt32);
  }
  f = message.getCostDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * map<string, CostAnalysisMetadata> model_costs = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata>}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getModelCostsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.org.codetricks.construction.code.assistant.service.cost.CostAnalysisMetadata));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.clearModelCostsMap = function() {
  this.getModelCostsMap().clear();
  return this;
};


/**
 * optional double total_cost_usd = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getTotalCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setTotalCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 total_tokens = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getTotalTokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setTotalTokens = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string primary_model = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getPrimaryModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setPrimaryModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 total_duration_ms = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getTotalDurationMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setTotalDurationMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 total_items_analyzed = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getTotalItemsAnalyzed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setTotalItemsAnalyzed = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string pricing_date = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getPricingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setPricingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * map<int32, int32> combined_depth_counts = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getCombinedDepthCountsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.clearCombinedDepthCountsMap = function() {
  this.getCombinedDepthCountsMap().clear();
  return this;
};


/**
 * optional CostDataSource cost_data_source = 9;
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.CostDataSource}
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.getCostDataSource = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.cost.CostDataSource} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.cost.CostDataSource} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} returns this
 */
proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis.prototype.setCostDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.cost.CostDataSource = {
  COST_DATA_SOURCE_UNSPECIFIED: 0,
  COST_DATA_SOURCE_LLM_GENERATED: 1,
  COST_DATA_SOURCE_CACHED_REPORT: 2,
  COST_DATA_SOURCE_CANCELLED_EARLY: 3,
  COST_DATA_SOURCE_FAILED_EARLY: 4,
  COST_DATA_SOURCE_NON_LLM: 5,
  COST_DATA_SOURCE_MOCK: 6
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service.cost);
